import { DocumentDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetAnfrageReportAttachmentsResolver  {
  constructor(protected anfrageService: AnfrageService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected portalContextService: PortalContextService){}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DocumentDisplayModel[] | null | undefined> {
    let id: string = <string>route.params['id'];
    let sectionId: string = <string>route.params['abschnittid'];
    let reportid: string = <string>route.params['reportid'];

    await this.unfinishedHttpMethodsService.waitByUrl(state.url);

    if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.attachments)
      if(!this.portalContextService.CurrentBericht)
        return of(this.portalContextService.CurrentAnfrage.attachments.filter(attachment => attachment.documententyp?.sectionId == sectionId)).toPromise();

    return this.anfrageService.apiAnfrageAnfrageIdAttachmentGet({ anfrageId: id, loadContent: false, projektberichtId: reportid, loadDocumentType: true }).pipe(map(response => {
      if (response) {
        if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.attachments || this.portalContextService.CurrentBericht)
          this.portalContextService.CurrentAnfrage.attachments = response;

        if(this.portalContextService.CurrentAnfrage?.attachments)
          return this.portalContextService.CurrentAnfrage.attachments.filter(attachment => attachment.documententyp?.sectionId == sectionId);

        return response;
      }

      return undefined;
    })).toPromise();
  }
}